import RestService from './RestService';

export default class Webhooks extends RestService {
    // parentId is a companyId when reached via the Companies service, or a
    // partnerId via the Partners service. Both resolve to <parent>/<id>/webhooks.
    constructor(parentService, parentId) {
        if (parentService && parentId)
            super(`${parentService.baseUrl}/${parentId}/webhooks`);
        else throw new Error('parent service and id are required');
    }
}
